export default __webpack_public_path__ + "static/media/codingninjasIcon.d603a965.svg";